import styled from "styled-components";
import {
  Avatar,
  AvatarBadge,
  Box,
  Button,
  Center,
  Flex,
  Image,
  MenuButton,
  PopoverBody,
  PopoverContent,
  Text,
} from "@chakra-ui/react";

export const ContainerFlex = styled(Box)`
  box-shadow: 10px 15px 5px #f0f4f5;
  display: flex;
  width: 100%;
  background-color: white;
  font-family: Akrobat;
  justify-content: center;
  height: 110px;
`;
export const Container1 = styled(Box)`
  margin-right: 2rem;
  margin-top: 0.7rem;
  display: flex;
`;
export const ImagemLogo = styled(Image)`
  height: 100px;
  width: auto;
  display: block;
  object-fit: scale-down;
  cursor: pointer;
`;
export const ContainerCenterListMenu = styled(Center)`
  height: 100%;

  @media (max-width: 1350px) {
    width: 750px;
  }
`;
export const ContainerPopoverContent = styled(PopoverContent)`
  box-shadow: none !important;
`;
export const ContainerPopoverBody = styled(PopoverBody)`
  ::-webkit-scrollbar {
    height: 15px;
  }
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 10px #dfd;
  }
  ::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.53);
  }
`;
export const ContainerCenter = styled(Center)``;
export const ContainerFlex2 = styled(Flex)`
  margin-top: 1rem;
  padding-left: 1rem;
  @media (max-width: 1350px) {
  }
`;
export const Container2 = styled(Box)`
  cursor: pointer;
  margin-left: 1rem;
`;
export const AvatarContainer = styled(Avatar)`
  margin-top: -0.7rem;
`;
export const AvatarBadgeContainer = styled(AvatarBadge)`
  border-color: white;
  background: green;
`;
export const Container3 = styled(Flex)`
  height: 50px;
  margin-top: -10px;
  animation: swing-in-top-fwd 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  @keyframes swing-in-top-fwd {
    0% {
      transform: rotateX(-100deg);
      transform-origin: top;
      opacity: 0;
    }
    100% {
      transform: rotateX(0deg);
      transform-origin: top;
      opacity: 1;
    }
  }
`;
export const ContainerFlex3 = styled(Center)`
  margin-left: 0.3rem;
`;
export const TextDate = styled(Text)`
  color: gray;
  margin-left: 0.7rem;
`;
export const ButtonItem = styled(Button)`
  letter-spacing: 0.02rem;
  font-family: Akrobat;
`;
export const ButtonItemFilho = styled(Button)`
  margin-right: 1rem;
  letter-spacing: 1px;
  position: relative;
  z-index: 1;
  border-radius: 4px;
  transition: ease-out 0.3s;
  box-shadow: none !important;
  font-family: 2rem;
  height: 50px;
  outline: none;
  font-weight: 600;
  border: 1px solid #92ba1f;
  background-color: white;
  &:active {
    transform: translateY(2px);
  }
  &:hover,
  &:focus {
    color: white;
    border: 1px solid #92ba1f;
    transform: scale(1.05);
  }
  &::before {
    transition: 0.5s all ease;
    position: absolute;
    top: 0;
    left: 50%;
    right: 50%;
    bottom: 0;
    opacity: 0;
    content: "";
    background-color: #92ba1f;
  }
  &:hover::before,
  &:focus::before {
    transition: 0.5s all ease;
    left: 0;
    right: 0;
    opacity: 1;
    z-index: -1;
  }
`;
export const MenuButtonSair = styled(MenuButton)`
  transition: all 0.2s;
  margin-top: 1.5rem;
  border-width: 1px;
  color: black;
  box-shadow: none !important;
  &:hover {
    border-color: #92ba1f;
  }
`;
